export enum HandedInAssignemntsPermissions {
  MboHandedInAssignments = 'mbo-handed-in-assignments',
  VoHandedInAssignments = 'vo-handed-in-assignments',
  HandedInAssignments = 'handed-in-assignments',
  NotAssigned = 'not-assigned',
}
